import { FC } from 'react';

export type TicketIconProps = {};

export const TicketIcon: FC<TicketIconProps> = ({}) => (
  <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.6668 21.3337V18.667M26.6668 33.3337V30.667M26.6668 45.3337V42.667M13.8668 10.667H50.1335C53.1204 10.667 54.6139 10.667 55.7548 11.2483C56.7583 11.7596 57.5742 12.5755 58.0855 13.579C58.6668 14.7199 58.6668 16.2134 58.6668 19.2003V22.667C53.5122 22.667 49.3335 26.8457 49.3335 32.0003C49.3335 37.155 53.5122 41.3337 58.6668 41.3337V44.8003C58.6668 47.7873 58.6668 49.2807 58.0855 50.4216C57.5742 51.4251 56.7583 52.241 55.7548 52.7524C54.6139 53.3337 53.1204 53.3337 50.1335 53.3337H13.8668C10.8799 53.3337 9.38641 53.3337 8.24555 52.7524C7.24202 52.241 6.42612 51.4251 5.91479 50.4216C5.3335 49.2807 5.3335 47.7873 5.3335 44.8003V41.3337C10.4882 41.3337 14.6668 37.155 14.6668 32.0003C14.6668 26.8457 10.4882 22.667 5.3335 22.667V19.2003C5.3335 16.2134 5.3335 14.7199 5.91479 13.579C6.42612 12.5755 7.24202 11.7596 8.24555 11.2483C9.38641 10.667 10.8799 10.667 13.8668 10.667Z"
      stroke="url(#paint0_linear_101_44438)"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_101_44438"
        x1="55.1327"
        x2="1.15295"
        y1="50.667"
        y2="36.8689"
      >
        <stop stop-color="#3EBDDA" />
        <stop offset="1" stop-color="#548CE4" />
      </linearGradient>
    </defs>
  </svg>
);
